import { styled } from '@mui/material/styles';
// material
import { Box, Typography, Container } from '@mui/material';
// components
import Page from '../../components/Page';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));

// ----------------------------------------------------------------------

export default function AccessDeniedPage() {
  return (
    <RootStyle title="Access denied">
      <Container>
        <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
          <Typography variant="h3" paragraph>
            Access denied
          </Typography>
          <Typography sx={{ color: 'text.secondary' }}>
            You do not have the necessary rights to use this application.
          </Typography>
        </Box>
      </Container>
    </RootStyle>
  );
}
